import React from 'react';
import { ContentHeadingProps } from '../../models/TopLevelTemplateComponentProps';
import { headingSet } from '../../services/TemplateUtils';
import { Palette } from 'Palette';
import { StyledHeading } from '../styles/styles';

interface LeftRightListHeadingBlockProps {
  heading: ContentHeadingProps;
  tone?: keyof typeof Palette;
}

export default function LeftRightListHeadingBlock({
  heading,
  tone,
}: LeftRightListHeadingBlockProps) {
  if (!headingSet(heading)) return null;
  return (
    <StyledHeading headerVariant="heading2" tone={tone}>
      {heading.content}
    </StyledHeading>
  );
}
